/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card } from "antd";
import { DeleteIcon, PlusIcon } from "../../../../../../atoms/CustomIcons";
import { SelectField } from "../../../../../../atoms/FormFields";

export default function EquipmentBox(props: any) {
  const { control, equipmentData, addEquipment, setAddEquipment } = props;

  return (
    <Card>
      <div className="card_top">
        <div className="card_left">
          <h4>Equipment</h4>
          <p style={{ marginBottom: "16px" }}>
            Equipment will be listed in the work order details for the crew and
            managers.
          </p>

          {addEquipment ? (
            <div className="equipment_wrapper">
              <div className="equipment_select">
                <SelectField
                  fieldName="equipment"
                  label="Equipment"
                  control={control}
                  selectOption={equipmentData}
                  iProps={{
                    placeholder: "Select equipment",
                    mode: "multiple",
                  }}
                />
              </div>

              <div className="equipment_delete">
                <Button
                  htmlType="button"
                  className="only_icon"
                  onClick={() => setAddEquipment(false)}
                  icon={<DeleteIcon />}
                />
              </div>
            </div>
          ) : (
            <div className="whenEmpty">
              <h3> There is no equipment </h3>
              <p> Click “+” to add equipment to this service. </p>
              <Button
                type="primary"
                className="outlined-btn btn-sm"
                icon={<PlusIcon style={{ color: "#151718" }} />}
                onClick={() => setAddEquipment(true)}
                style={{ marginBottom: 0 }}
              >
                Add equipment
              </Button>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
